import React from 'react';

import AutocompletedAddressFormGroup from 'components/form/autocompleted_address_form_group';
import ManagedFormGroup from 'components/form/managed_input/form_group';

import type { InputProps } from './types';

export default function AddressInput({ country, options, value, onChange }: InputProps) {
  if (options.address?.show === false) {
    return null;
  }

  const props = {
    hasError: options.address?.hasError,
    label: 'Address',
    required: options.address?.required !== false,
    onChange: changes => onChange({ ...value, ...changes }),
  };

  if (country.isoCode === 'US') {
    return (
      <AutocompletedAddressFormGroup
        address={value.address}
        city={value.city}
        country={country}
        state={value.state}
        zip={value.zip}
        {...props}
      />
    );
  } else {
    return (
      <ManagedFormGroup
        {...props}
        name="address"
        value={value.address}
      />
    );
  }
}
